const cards = [
  {
    title: '娱乐圈年度最大塌房事件：时间线全梳理',
    desc: '从第一手爆料到后续持续发酵，完整还原某顶流明星塌房事件始末，多段独家视频首次公开。',
    tag: '深度报道',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20entertainment%20scene%20with%20warm%20stage%20lighting%2C%20dark%20moody%20atmosphere%2C%20premium%20editorial%20photography%2C%20amber%20and%20crimson%20tones%2C%20abstract%20composition%2C%20no%20text%2C%20no%20people&width=640&height=420&seq=card-01&orientation=landscape',
  },
  {
    title: '网红经济泡沫破裂：头部主播集体面临转型',
    desc: '直播带货红利消退，多位千万粉级别网红收入断崖式下跌，行业洗牌加速中的独家分析。',
    tag: '行业分析',
    img: 'https://readdy.ai/api/search-image?query=Modern%20social%20media%20influencer%20studio%20with%20dramatic%20lighting%2C%20dark%20cinematic%20atmosphere%2C%20warm%20amber%20glow%2C%20premium%20editorial%20photography%2C%20deep%20shadows%2C%20no%20text%2C%20no%20people&width=640&height=420&seq=card-02&orientation=landscape',
  },
  {
    title: '某知名连锁品牌食品安全问题实地调查',
    desc: '记者深入多家门店后厨，拍摄到多项卫生违规行为，监管部门已介入调查并发布整改通知。',
    tag: '实地调查',
    img: 'https://readdy.ai/api/search-image?query=Restaurant%20kitchen%20interior%20with%20dramatic%20moody%20lighting%2C%20dark%20atmosphere%2C%20investigative%20style%2C%20premium%20editorial%20photography%2C%20amber%20and%20deep%20shadow%20tones%2C%20no%20text%2C%20no%20people&width=640&height=420&seq=card-03&orientation=landscape',
  },
  {
    title: '体育圈黑哨真相：退役裁判匿名接受独家专访',
    desc: '一位曾在顶级联赛执法多年的退役裁判，首次在镜头前披露行业内幕和系统性的规则漏洞。',
    tag: '独家专访',
    img: 'https://readdy.ai/api/search-image?query=Sports%20stadium%20with%20dramatic%20lighting%2C%20warm%20spotlight%20rays%2C%20dark%20atmosphere%2C%20premium%20editorial%20photography%2C%20cinematic%20composition%2C%20amber%20and%20crimson%20tones%2C%20no%20text%2C%20no%20people&width=640&height=420&seq=card-04&orientation=landscape',
  },
  {
    title: 'AI创业风口变雷区：多家明星公司数据造假',
    desc: '一份行业调查报告揭露多家AI独角兽存在严重数据造假，投资圈震动，估值面临重估。',
    tag: '科技爆料',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20tech%20office%20with%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20warm%20amber%20glow%2C%20premium%20editorial%20photography%2C%20abstract%20composition%2C%20no%20text%2C%20no%20people&width=640&height=420&seq=card-05&orientation=landscape',
  },
  {
    title: '直播平台潜规则全揭秘：主播合约纠纷内幕',
    desc: '多位匿名主播联合发声，揭开直播平台合约中的霸王条款和不合理分成机制，引发行业反思。',
    tag: '行业内幕',
    img: 'https://readdy.ai/api/search-image?query=Livestream%20production%20studio%20with%20dramatic%20cinematic%20lighting%2C%20dark%20atmosphere%2C%20warm%20spotlight%20and%20deep%20shadows%2C%20premium%20editorial%20photography%2C%20no%20text%2C%20no%20people&width=640&height=420&seq=card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">图文资讯</h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">深度报道与独家分析，全方位了解每件黑料背后的真相</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {cards.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500/90 text-white text-xs font-medium rounded-md">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-bold text-foreground-800 group-hover:text-primary-500 transition-colors mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}